import api from './api';

const contactApi = {
  async submitRequest(payload) {
    const {
      name,
      email,
      phone = '',
      subject,
      message,
      source = 'website_contact_form',
    } = payload || {};

    const cleaned = {
      name: (name || '').toString().trim(),
      email: (email || '').toString().trim(),
      phone: (phone || '').toString().trim(),
      subject: (subject || '').toString().trim(),
      message: (message || '').toString().trim(),
      source: (source || 'website_contact_form').toString(),
    };

    const errors = [];
    if (cleaned.name.length < 2) errors.push('Please enter your full name.');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cleaned.email)) errors.push('Please enter a valid email address.');
    if (cleaned.subject.length < 3) errors.push('Please add a subject line.');
    if (cleaned.message.length < 10) errors.push('Message should be at least 10 characters long.');
    if (errors.length) {
      const err = new Error(errors[0]);
      err.details = errors;
      throw err;
    }

    const resp = await api.post('/contact-requests', cleaned);
    const data = resp?.data;
    const record = data?.data || data?.record || data;
    return { ok: true, record, stored: 'api' };
  },

  async listRequests() {
    const resp = await api.get('/contact-requests', { params: { per_page: 100 } });
    const data = resp?.data;
    const rows = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
    return rows.sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));
  },

  async updateStatus(id, patch = {}) {
    await api.patch(`/contact-requests/${encodeURIComponent(id)}`, patch);
    return this.listRequests();
  },

  async deleteRequest(id) {
    await api.delete(`/contact-requests/${encodeURIComponent(id)}`);
    return this.listRequests();
  },

  async stats() {
    const list = await this.listRequests().catch(() => []);
    return {
      total: list.length,
      new: list.filter((r) => r.status === 'new').length,
      read: list.filter((r) => r.read).length,
      replied: list.filter((r) => r.status === 'replied').length,
    };
  },
};

export default contactApi;
